import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import TVStationHeatmapCard from './TVStationHeatmapCard';
import tvBroadcast from './tvBroadcastStyles';

/** 画面6：先週の流れ（4地点まとめ・青空背景・タイトルは週間画面と同じ左上帯） */
function TVPastWeekOverviewPanel({ data, compact = false, loading = false }) {
  const { panelTitle, rowHeader, rowLabels, colLabels, cells, summary } = data;
  const b = tvBroadcast;

  return (
    <Box
      sx={{
        ...b.root,
        opacity: loading ? 0.5 : 1,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          px: compact ? 0.55 : 0.75,
          py: compact ? 0.35 : 0.45,
          bgcolor: 'rgba(255,255,255,0.78)',
          borderBottom: '3px solid #fff',
          boxShadow: '0 2px 12px rgba(13,74,143,0.15)',
        }}
      >
        <Typography sx={b.title(compact)}>{panelTitle}</Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: compact ? 0.5 : 0.85,
          py: compact ? 0.35 : 0.5,
        }}
      >
        <TVStationHeatmapCard
          rowHeader={rowHeader}
          rowLabels={rowLabels}
          colLabels={colLabels}
          cells={cells}
          compact={compact}
          sizePreset="pastWeekOverview"
          airy
          fillWidth
        />
      </Box>

      {summary && (
        <Box
          sx={{
            ...b.ticker(compact),
            background: 'rgba(21, 101, 184, 0.82)',
            backdropFilter: 'blur(4px)',
          }}
        >
          <Typography sx={b.tickerText(compact)}>{summary}</Typography>
        </Box>
      )}
    </Box>
  );
}

TVPastWeekOverviewPanel.propTypes = {
  data: PropTypes.shape({
    panelTitle: PropTypes.string.isRequired,
    rowHeader: PropTypes.string,
    rowLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
    colLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
    cells: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
    summary: PropTypes.string.isRequired,
  }).isRequired,
  compact: PropTypes.bool,
  loading: PropTypes.bool,
};

export default TVPastWeekOverviewPanel;
